<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="6" md="4">
        <v-card>
          <v-card-title class="text-h5">Login</v-card-title>
          <v-card-text>
            <v-form @submit.prevent="handleLogin">
              <v-text-field v-model="email" label="Email" type="email" required />
              <v-text-field v-model="password" label="Senha" type="password" required />
              <v-btn type="submit" color="primary" block class="mt-4">Entrar</v-btn>
              <v-alert v-if="erro" type="error" class="mt-3" dense>Email ou senha inválidos.</v-alert>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
const email = ref('')
const password = ref('')
const erro = ref(false)
const auth = useAuthStore()
const router = useRouter()
const handleLogin = async () => {
  const sucesso = await auth.login(email.value, password.value)
  if (sucesso) {
    router.push('/admin/produtos')
  } else {
    erro.value = true
  }
}
</script>